import React, { useState } from 'react'
import styled from 'styled-components'
import { CheckBox } from '../forms/check-box'

const ParameterAccordionItem = ({parameterLabel, parameterValue, children, selectedFilters, handleParameterChange}) => {
  const [isOpen, setIsOpen] = useState(true);
  const parentEl = selectedFilters.find(el => el.id === parameterValue);
  const choiceAmount = parentEl.values.length;

  const parameterChildren = (children, disabled = false) => {
    return (
      <ParameterList>
        {children.map((child, index) => {
          const hasChildren = child.children && child.children.length > 0;
          let isChecked = (parentEl && parentEl.values) ? parentEl.values.includes(child.value) : false;
          if (disabled) {
            isChecked = true;
            if(parentEl.values.includes(child.value)){
              handleParameterChange(false, child.value, parameterValue)
            }
          }
          return (
            <li key={index}>
              <CheckBox
                name={"user-parameter"}
                label={child.label}
                id={`param-${index}-${child.label.replace(/\s/g, '')}`}
                checked={isChecked}
                onChange={(checked) => handleParameterChange(checked, child.value, parameterValue)}
                disabled={disabled}
              />
              {hasChildren && parameterChildren(child.children, hasChildren && isChecked)}
            </li>
          )
        })}
      </ParameterList>
    )
  }

  return (
    <AccordionItem className="user-param">
      <ItemHeader onClick={() => setIsOpen(!isOpen)}>
        <h6 className={"parameter-title"}>{parameterLabel} {choiceAmount ? `(${choiceAmount})` : ""}</h6>
        <span className="ant-select-arrow" />
      </ItemHeader>
      {isOpen &&
        <ItemContent>
          {parameterChildren(children)}
        </ItemContent>
      }
    </AccordionItem>
  )
}

export default ParameterAccordionItem;

const ItemHeader = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 1.25rem 2px;
  cursor: pointer;
  
  .ant-select-arrow {
    margin-top: -10px;
    font-size: 26px;
  }
  
  > .parameter-title {
    font-size: 15px;
    margin: 0;
  }
`;

const ItemContent = styled.div`
  padding-bottom: 1.5rem;
`

const AccordionItem = styled.div`
  + .user-param {
    border-top: 1px solid #E4E7EB;
  }
`;

const ParameterList = styled.ul`
  margin: 0;
  li {
    
    + li {
      margin-top: 15px;
    }
  }
  
  ul {
    margin: 15px 0 4px 1rem;
  }
`;


// WEBPACK FOOTER //
// ./src/components/ui/parameter-accordion-item.js